import React from "react";

export const ErrorPage = ({stencil}) => {
    const {errorMessage, refreshButtonLabel, redirectButtonLabel, redirectButtonLink} = stencil;

    return (
        <div className={'error-page'}>
            <div className={'error-page__text'} dangerouslySetInnerHTML={{__html: errorMessage}}/>
            <div className={'error-page__buttons'}>
                <button className={'btn btn-primary'}
                        onClick={() => window.location.reload()}>{refreshButtonLabel}</button>
                <button className={'btn btn-primary'}
                        onClick={() => window.location.href = redirectButtonLink}>{redirectButtonLabel}</button>
            </div>
        </div>
    );
}
